module.exports = __webpack_public_path__ + "static/scale-model-of-reno-arch-in-reno-nevada-0b8538cf981e5b92d52616e737ee822b.png";